<template>
	<div class="_change-status _modal bg-white">
		<div
			class="
				_modal__content
				md-down:px-4
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					src="@/assets/images/illustrations/date-picker.png"
					alt=""
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
				"
			>
				Chỉnh sửa ngày áp dụng Kế hoạch hiện tại
			</div>

			<div class="text-center text-neutral-500 mt-2">
				Ngày áp dụng là ngày bạn sẽ bắt đầu dạy các mục tiêu trong kế
				hoạch này.
			</div>
			<VueDatepicker
				class="input-date w-full mt-4"
				placeholder="Chọn ngày"
				autoApply
				:enableTimePicker="false"
				uid="filter-by-date"
				minutesIncrement="30"
				v-model="date"
				format="dd-MM-yyyy"
				:min-date="props.done_at"
			>
				<template #input-icon>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
							fill="#94A3B8"
						/>
					</svg>
				</template>
			</VueDatepicker>
		</div>

		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Quay lại
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				@click="submit"
			>
				Tiếp tục
			</button>
		</div>
	</div>
</template>
<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import { $api } from '@/services';
import { useStore } from 'vuex';
import { isTutorialVirtualStudent } from '@/features/tutorial/virtualStudent';

const emit = defineEmits(['close']);
const date = ref(null);
const props = defineProps(['applyDate', 'studentId', 'planId']);
const store = useStore();

const submit = async () => {
	if (isTutorialVirtualStudent(props.studentId)) {
		emit('submit');
		return;
	}
	try {
		let data = new Date(date.value);
		const formattedDate = data.toISOString().split('T')[0];
		const res = await $api.goal.changeApplyDate(
			props.studentId,
			props.planId,
			{
				plan: {
					apply_date: formattedDate,
				},
			}
		);
		if (res) {
			await store.dispatch('setAlertMessage', {
				message: 'Chỉnh sửa ngày áp dụng thành công',
			});
			emit('submit');
		}
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
</script>
